"use client";
import {
	faBalanceScale,
	faCircleInfo,
	faDatabase,
	faFileContract,
	faGavel,
	faGlobe,
	faListCheck,
	faLock,
	faShieldHalved,
	faSitemap,
	faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useState } from "react";

const PrivacyPage = () => {
	const [activeSection, setActiveSection] = useState<string | null>(null);

	const privacySections = [
		{
			id: "introduccion",
			title: "Introducción",
			icon: faCircleInfo,
			content: (
				<>
					<p className="mb-4">
						El Titular le informa sobre su Política de Privacidad respecto del tratamiento y protección de los
						datos de carácter personal de los usuarios y clientes que puedan ser recabados durante la
						navegación, al comprar un producto o al contratar un servicio a través del Sitio Web:{" "}
						<a href="/" className="text-red-400 hover:text-red-300">
							https://www.losamosdelcalabozo.com
						</a>
					</p>
					<p className="mb-4">
						En este sentido, el Titular garantiza el cumplimiento de la normativa vigente en materia de
						protección de datos personales, reflejada en la Ley Orgánica 3/2018, de 5 de diciembre, de
						Protección de Datos Personales y de Garantía de Derechos Digitales (LOPD GDD). Cumple también con
						el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a
						la protección de las personas físicas (RGPD).
					</p>
					<p>
						El uso de sitio Web implica la aceptación de esta Política de Privacidad así como las condiciones
						incluidas en el{" "}
						<a href="/aviso-legal/" className="text-red-400 hover:text-red-300">
							Aviso Legal
						</a>
						.
					</p>
				</>
			),
		},
		{
			id: "identidad",
			title: "Identidad del Responsable",
			icon: faUserShield,
			content: (
				<>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							<strong>Responsable:</strong> Sergio de Isidro Hontana.
						</li>
						<li>
							<strong>NIF:</strong> 04604219X
						</li>
						<li>
							<strong>Domicilio:</strong> Plaza campo de Criptana 25, 3A, Madrid - España.
						</li>
						<li>
							<strong>Correo electrónico:</strong> legal@losamosdelcalabozo.com
						</li>
						<li>
							<strong>Sitio Web:</strong>{" "}
							<a href="/" className="text-red-400 hover:text-red-300">
								https://www.losamosdelcalabozo.com
							</a>
						</li>
					</ul>
				</>
			),
		},
		{
			id: "principios",
			title: "Principios aplicados en el tratamiento de datos",
			icon: faShieldHalved,
			content: (
				<>
					<p className="mb-4">
						En el tratamiento de sus datos personales, el Titular aplicará los siguientes principios que se
						ajustan a las exigencias del nuevo reglamento europeo de protección de datos (RGPD):
					</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							Principio de licitud, lealtad y transparencia: El Titular siempre requerirá el consentimiento
							para el tratamiento de los datos personales que puede ser para uno o varios fines específicos
							sobre los que el Titular informará al Usuario previamente con absoluta transparencia.
						</li>
						<li>
							Principio de minimización de datos: El Titular solicitará solo los datos estrictamente
							necesarios para el fin o los fines que los solicita.
						</li>
						<li>
							Principio de limitación del plazo de conservación: El Titular mantendrá los datos personales
							recabados durante el tiempo estrictamente necesario para el fin o los fines del tratamiento. El
							Titular informará al Usuario del plazo de conservación correspondiente según la finalidad.
							<br />
							En el caso de suscripciones, el Titular revisará periódicamente las listas y eliminará aquellos
							registros inactivos durante un tiempo considerable.
						</li>
						<li>
							Principio de integridad y confidencialidad: Los datos personales recabados serán tratados de tal
							manera que su seguridad, confidencialidad e integridad está garantizada.
							<br />
							El Titular toma las precauciones necesarias para evitar el acceso no autorizado o uso indebido
							de los datos de sus usuarios por parte de terceros.
						</li>
					</ul>
				</>
			),
		},
		{
			id: "obtencion",
			title: "Obtención de datos personales",
			icon: faDatabase,
			content: <p>Para navegar por el sitio Web no es necesario que facilite ningún dato personal.</p>,
		},
		{
			id: "derechos",
			title: "Derechos",
			icon: faListCheck,
			content: (
				<>
					<p className="mb-4">El Titular le informa que sobre sus datos personales tiene derecho a:</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>Solicitar el acceso a los datos almacenados.</li>
						<li>Solicitar una rectificación o la supresión.</li>
						<li>Solicitar la limitación de su tratamiento.</li>
						<li>Oponerse al tratamiento.</li>
					</ul>
					<p className="mb-4">No puede ejercitar el derecho a la portabilidad de los datos.</p>
					<p className="mb-4">
						El ejercicio de estos derechos es personal y por tanto debe ser ejercido directamente por el
						interesado, solicitándolo directamente al Titular, lo que significa que cualquier cliente,
						suscriptor o colaborador que haya facilitado sus datos en algún momento, puede dirigirse al
						Titular y pedir información sobre los datos que tiene almacenados y cómo los ha obtenido,
						solicitar la rectificación de los mismos, oponerse al tratamiento, limitar su uso o solicitar la
						supresión de esos datos en los ficheros del Titular.
					</p>
					<p className="mb-4">
						Para ejercitar sus derechos tiene que enviar su petición junto con una fotocopia del Documento
						Nacional de Identidad o equivalente a la dirección de correo electrónico:
						legal@losamosdelcalabozo.com
					</p>
					<p className="mb-4">
						El ejercicio de estos derechos no incluye ningún dato que el Titular esté obligado a conservar con
						fines administrativos, legales o de seguridad.
					</p>
					<p>
						Tiene derecho a la tutela judicial efectiva y a presentar una reclamación ante la autoridad de
						control, en este caso, la Agencia Española de Protección de Datos, si considera que el tratamiento
						de datos personales que le conciernen infringe el Reglamento.
					</p>
				</>
			),
		},
		{
			id: "finalidad-tratamiento",
			title: "Finalidad del tratamiento de datos personales",
			icon: faSitemap,
			content: (
				<>
					<p className="mb-4">
						Cuando usted se conecta al Sitio Web para mandar un correo al Titular, se suscribe a su boletín o
						contrata un producto o un servicio está facilitando información de carácter personal de la que el
						responsable es el Titular. Esta información puede incluir datos de carácter personal como pueden
						ser su dirección IP, nombre y apellidos, dirección física, dirección de correo electrónico, número
						de teléfono, y otra información. Al facilitar esta información, da su consentimiento para que su
						información sea recopilada, utilizada, gestionada y almacenada por —{" "}
						<a
							href="https://www.vercel.com/"
							className="text-red-400 hover:text-red-300"
							target="_blank"
							rel="nofollow"
						>
							https://www.vercel.com/
						</a>{" "}
						— sólo como se describe en las páginas:
					</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							<a href="/aviso-legal/" className="text-red-400 hover:text-red-300">
								Aviso Legal
							</a>
						</li>
						<li>
							<a href="/politica-de-privacidad/" className="text-red-400 hover:text-red-300">
								Política de Privacidad
							</a>
						</li>
					</ul>
					<p className="mb-4">
						Los datos personales y la finalidad del tratamiento por parte del Titular es diferente según el
						sistema de captura de información:
					</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							Formularios de contratación de productos o servicios: El Titular solicita datos personales entre
							los que pueden estar: nombre y apellidos, documento de identidad (número de identificación
							fiscal, número de identificación de extranjero, pasaporte o permiso de residencia), dirección de
							correo electrónico, dirección postal, número de teléfono y datos de pago (métodos de pago o
							datos bancarios) con la finalidad de mantener una relación comercial con el Usuario, realizar el
							envío de los pedidos, prestar los servicios contratados y para realizar la facturación y el
							cobro de los productos o servicios contratados.
						</li>
					</ul>
					<p className="mb-4">Existen otras finalidades por las que el Titular trata datos personales:</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							Para garantizar el cumplimiento de las condiciones recogidas en la página de Aviso Legal y de la
							ley aplicable. Esto puede incluir el desarrollo de herramientas y algoritmos que ayuden al Sitio
							Web a garantizar la confidencialidad de los datos personales que recoge.
						</li>
						<li>Para apoyar y mejorar los servicios que ofrece este Sitio Web.</li>
						<li>
							Para analizar la navegación de los usuarios. El Titular recoge otros datos no identificativos
							que se obtienen mediante el uso de cookies que se descargan en el ordenador del Usuario cuando
							navega por el Sitio Web cuyas características y finalidad están detalladas en la página de{" "}
							<a href="/politica-de-cookies/" className="text-red-400 hover:text-red-300">
								Política de Cookies
							</a>
							.
						</li>
						<li>
							Para gestionar las redes sociales. El Titular tiene presencia en redes sociales.
							<br />
							Si usted se hace seguidor en las redes sociales del Titular el tratamiento de los datos
							personales se regirá por este apartado, así como por aquellas condiciones de uso, políticas de
							privacidad y normativas de acceso que pertenezcan a la red social que proceda en cada caso y que
							ha aceptado previamente.
							<br />
							Puede consultar las políticas de privacidad de las principales redes sociales en estos enlaces:
							<ul className="list-disc pl-6 mt-2 space-y-2">
								<li>
									<a
										href="https://www.facebook.com/help/cookies"
										className="text-red-400 hover:text-red-300"
										target="_blank"
										rel="nofollow"
									>
										Facebook
									</a>
								</li>
								<li>
									<a
										href="https://twitter.com/privacy"
										className="text-red-400 hover:text-red-300"
										target="_blank"
										rel="nofollow"
									>
										Twitter
									</a>
								</li>
								<li>
									<a
										href="https://www.linkedin.com/legal/cookie-policy"
										className="text-red-400 hover:text-red-300"
										target="_blank"
										rel="nofollow"
									>
										Linkedin
									</a>
								</li>
								<li>
									<a
										href="https://www.youtube.com/privacy"
										className="text-red-400 hover:text-red-300"
										target="_blank"
										rel="nofollow"
									>
										YouTube
									</a>
								</li>
								<li>
									<a
										href="https://www.instagram.com/legal/privacy/"
										className="text-red-400 hover:text-red-300"
										target="_blank"
										rel="nofollow"
									>
										Instagram
									</a>
								</li>
							</ul>
							<p className="mt-4">
								El Titular tratará sus datos personales con la finalidad de administrar correctamente su
								presencia en la red social, informarle de sus actividades, productos o servicios, así como
								para cualquier otra finalidad que las normativas de las redes sociales permiten.
							</p>
							<p>
								En ningún caso el Titular utilizará los perfiles de seguidores en redes sociales para enviar
								publicidad de manera individual.
							</p>
						</li>
					</ul>
				</>
			),
		},
		{
			id: "seguridad",
			title: "Seguridad de los datos personales",
			icon: faLock,
			content: (
				<>
					<p className="mb-4">
						Para proteger sus datos personales, el Titular toma todas las precauciones razonables y sigue las
						mejores prácticas de la industria para evitar su pérdida, mal uso, acceso indebido, divulgación,
						alteración o destrucción de los mismos.
					</p>
					<p>
						El sitio Web está alojado en:{" "}
						<a
							href="https://www.vercel.com/"
							className="text-red-400 hover:text-red-300"
							target="_blank"
							rel="nofollow"
						>
							https://www.vercel.com/
						</a>
						. La seguridad de los datos está garantizada, ya que toman todas las medidas de seguridad
						necesarias para ello. Puede consultar su política de privacidad para tener más información.
					</p>
				</>
			),
		},
		{
			id: "contenidos-externos",
			title: "Contenido de otros sitios web",
			icon: faGlobe,
			content: (
				<>
					<p className="mb-4">
						Las páginas de este sitio Web pueden incluir contenido incrustado (por ejemplo, vídeos, imágenes,
						artículos, etc.). El contenido incrustado de otras web se comporta exactamente de la misma manera
						que si hubiera visitado la otra web.
					</p>
					<p>
						Estos sitios Web pueden recopilar datos sobre usted, utilizar cookies, incrustar un código de
						seguimiento adicional de terceros, y supervisar su interacción usando este código.
					</p>
				</>
			),
		},
		{
			id: "cookies",
			title: "Política de Cookies",
			icon: faCircleInfo,
			content: (
				<>
					<p className="mb-4">
						Para que este sitio Web funcione correctamente necesita utilizar cookies, que es una información
						que se almacena en su navegador web.
					</p>
					<p>
						Puede consultar toda la información relativa a la política de recogida y tratamiento de las
						cookies en la página de{" "}
						<a href="/politica-de-cookies/" className="text-red-400 hover:text-red-300">
							Política de Cookies
						</a>
						.
					</p>
				</>
			),
		},
		{
			id: "legitimacion",
			title: "Legitimación para el tratamiento de datos",
			icon: faGavel,
			content: (
				<>
					<p className="mb-4">La base legal para el tratamiento de sus datos es:</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>El consentimiento del interesado.</li>
						<li>
							Ejecución del contrato o la aplicación de medidas precontractuales con el interesado, con el fin
							de proporcionarle un producto o servicio adquirido al Titular.
						</li>
						<li>Para cumplir las obligaciones legales.</li>
					</ul>
				</>
			),
		},
		{
			id: "categorias",
			title: "Categorías de datos personales",
			icon: faDatabase,
			content: (
				<>
					<p className="mb-4">Las categorías de datos personales que trata el Titular son:</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>Datos identificativos.</li>
						<li>No se tratan categorías de datos especialmente protegidos.</li>
					</ul>
				</>
			),
		},
		{
			id: "conservacion",
			title: "Conservación de datos personales",
			icon: faDatabase,
			content: (
				<p>Los datos personales proporcionados al Titular se conservarán hasta que solicite su supresión.</p>
			),
		},
		{
			id: "destinatarios",
			title: "Destinatarios de datos personales",
			icon: faUserShield,
			content: (
				<>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							<strong>Google Analytics</strong> es un servicio de analítica web prestado por Google, Inc., una
							compañía de Delaware cuya oficina principal está en 1600 Amphitheatre Parkway, Mountain View
							(California), CA 94043, Estados Unidos ("Google").
							<br />
							Google Analytics utiliza "cookies", que son archivos de texto ubicados en tu ordenador, para
							ayudar al Titular a analizar el uso que hacen los Usuarios del sitio Web. La información que
							genera la cookie acerca del uso del sitio Web (incluyendo la dirección IP) será directamente
							transmitida y archivada por Google en los servidores de Estados Unidos.
							<br />
							Más información en:{" "}
							<a
								href="https://policies.google.com/privacy?hl=es-ES"
								className="text-red-400 hover:text-red-300"
								target="_blank"
								rel="nofollow"
							>
								https://analytics.google.com
							</a>
						</li>
					</ul>
					<p className="mb-4">
						Puede consultar como Google gestiona la privacidad en lo que respecta al uso de las cookies y otra
						información en la página de Política de privacidad de Google:{" "}
						<a
							href="https://policies.google.com/privacy?hl=es"
							className="text-red-400 hover:text-red-300"
							target="_blank"
							rel="nofollow"
						>
							https://policies.google.com/privacy?hl=es
						</a>
					</p>
					<p className="mb-4">
						También puede ver una lista de los tipos de cookies que utiliza Google y sus colaboradores y toda
						la información relativa al uso que hacen de las cookies publicitarias en:
					</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							<a
								href="https://policies.google.com/technologies/types?hl=es"
								className="text-red-400 hover:text-red-300"
								target="_blank"
								rel="nofollow"
							>
								Tipos de cookies que utiliza Google
							</a>
						</li>
						<li>
							<a
								href="https://policies.google.com/technologies/ads?hl=es"
								className="text-red-400 hover:text-red-300"
								target="_blank"
								rel="nofollow"
							>
								Cómo utiliza Google las cookies en publicidad
							</a>
						</li>
					</ul>
				</>
			),
		},
		{
			id: "navegacion",
			title: "Navegación Web",
			icon: faGlobe,
			content: (
				<>
					<p className="mb-4">
						Al navegar por el Sitio Web se pueden recoger datos no identificativos, que pueden incluir, la
						dirección IP, geolocalización, un registro de cómo se utilizan los servicios y sitios, hábitos de
						navegación y otros datos que no pueden ser utilizados para identificarle.
					</p>
					<p className="mb-4">El sitio Web utiliza los siguientes servicios de análisis de terceros:</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>Google Analytics.</li>
					</ul>
					<p className="mb-4">
						El Titular utiliza la información obtenida para obtener datos estadísticos, analizar tendencias,
						administrar el sitio, estudiar patrones de navegación y para recopilar información demográfica.
					</p>
					<p>
						El Titular no se hace responsable del tratamiento de los datos personales que realicen las páginas
						web a las que pueda acceder a través de los distintos enlaces que contiene el Sitio Web.
					</p>
				</>
			),
		},
		{
			id: "exactitud",
			title: "Exactitud y veracidad de los datos personales",
			icon: faBalanceScale,
			content: (
				<>
					<p className="mb-4">
						Usted se compromete a que los datos facilitados al Titular sean correctos, completos, exactos y
						vigentes, así como a mantenerlos debidamente actualizados.
					</p>
					<p>
						Como Usuario del Sitio Web es el único responsable de la veracidad y corrección de los datos
						remitidos al Sitio Web exonerando al Titular de cualquier responsabilidad al respecto.
					</p>
				</>
			),
		},
		{
			id: "aceptacion",
			title: "Aceptación y consentimiento",
			icon: faFileContract,
			content: (
				<>
					<p className="mb-4">
						Como Usuario del Sitio Web declara haber sido informado de las condiciones sobre protección de
						datos de carácter personal, acepta y consiente el tratamiento de los mismos por parte del Titular
						en la forma y para las finalidades indicadas en esta Política de Privacidad.
					</p>
					<p>
						Para contactar con el Titular, suscribirse a un boletín o realizar comentarios en este sitio Web
						tiene que aceptar la presente Política de Privacidad.
					</p>
				</>
			),
		},
		{
			id: "cambios",
			title: "Cambios en la Política de Privacidad",
			icon: faCircleInfo,
			content: (
				<>
					<p className="mb-4">
						El Titular se reserva el derecho a modificar la presente Política de Privacidad para adaptarla a
						novedades legislativas o jurisprudenciales, así como a prácticas de la industria.
					</p>
					<p>Estas políticas estarán vigentes hasta que sean modificadas por otras debidamente publicadas.</p>
				</>
			),
		},
	];

	const scrollToSection = (id: string) => {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
			setActiveSection(id);
		}
	};

	return (
		<main className="bg-black text-white">
			{/* Hero Section */}
			<section
				className="relative py-32 bg-cover bg-center"
				style={{ backgroundImage: "url('/images/collections/Precios/custom.webp')" }}
			>
				<div className="absolute inset-0 bg-black/60"></div>
				<div className="container mx-auto px-4 max-w-4xl relative z-10">
					<motion.h1
						className="font-amarante text-5xl md:text-7xl mb-6 text-center text-white"
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8 }}
					>
						<span className="headerFont inline-block pb-2 border-b-2 border-red-700">
							Política de Privacidad
						</span>
					</motion.h1>

					<motion.p
						className="text-xl text-gray-300 max-w-3xl mx-auto text-center mb-12"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ delay: 0.3, duration: 0.6 }}
					>
						<strong className="">Protección de datos personales en Los Amos del Calabozo</strong>
					</motion.p>
				</div>
			</section>

			{/* Quick Navigation */}
			<section className="py-8 bg-gray-900">
				<div className="container mx-auto px-4 max-w-4xl">
					<div className="flex flex-wrap justify-center gap-4">
						{privacySections.map((section) => (
							<button
								key={section.id}
								onClick={() => scrollToSection(section.id)}
								className={`px-4 py-2 rounded-md transition-all ${
									activeSection === section.id
										? "bg-red-700 text-white"
										: "bg-gray-800 text-gray-300 hover:bg-gray-700"
								}`}
							>
								<FontAwesomeIcon icon={section.icon} className="mr-2" />
								{section.title}
							</button>
						))}
					</div>
				</div>
			</section>

			{/* Main Content Section */}
			<section className="py-16 bg-black">
				<div className="container mx-auto px-4 max-w-4xl">
					{privacySections.map((section) => (
						<motion.div
							key={section.id}
							id={section.id}
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{ duration: 0.6 }}
							className="mb-16"
						>
							<h2 className="text-3xl font-amarante headerFont mb-8 border-b-2 border-red-700 pb-2 inline-block">
								<FontAwesomeIcon icon={section.icon} className="mr-3 text-red-500" />
								{section.title}
							</h2>

							<div
								className={`bg-gray-900 rounded-lg p-6 border-l-4 transition-all duration-300 ${
									activeSection === section.id
										? "border-red-500 shadow-lg shadow-red-900/20"
										: "border-red-700"
								}`}
							>
								<div className="text-gray-300">{section.content}</div>
							</div>
						</motion.div>
					))}
				</div>
			</section>
		</main>
	);
};

export default PrivacyPage;
